import AxiosClientService from '@/services/core/axios/axios';
import { APP_HOST } from '@/app.config';

class KzsApi {
  constructor() {
    this.api = AxiosClientService.instance;
  }

  /**
   *  Метод для получения списка кзс
   * @param {Object} params - Параметры запроса
   * @param {string} params.search - Строка поиска
   * @param {number} params.page - Номер страницы
   * @param {number} params.limit - Количество кзс на странице
   * @returns
   */
  async getKzsList(params) {
    const { data } = await this.api.get(`${APP_HOST}v2/monitoring/kzs/list`, { params });
    return data;
  }

  /**
   *  Метод для получения КЗС
   * @param {string} id - ID КЗС
   * @returns
   */
  async getKzs(id) {
    const { data } = await this.api.get(`${APP_HOST}v2/monitoring/kzs/${id}`);
    return data;
  }

  /**
   *  Метод для удаления кзс
   * @param {string} id - ID кзс
   * @returns
   */
  async deleteKzs(id) {
    const { data } = await this.api.delete(`${APP_HOST}v2/monitoring/kzs/${id}`);
    return data;
  }


  /**
   *  Метод для получения списка доступных алгоритмов
   * @param {Object} params - Параметры запроса
   * @param {string} params.kzsType - тип КЗС, выбранный пользователем
   * @param {string} params.kzsSubType - зависит от настройки "Участвует в формировании КЗС"(subType), проставленной пользователем в первом шаге формы
   * @returns
   */
  async getAvailableAlgorithms(params) {
    const { data } = await this.api.get(`${APP_HOST}v2/monitoring/kzs/algorithm-config`, { params });
    return data;
  }

    /**
   *  Метод для создания КЗС
   * @param {Object} data - Данные для создания КЗС
   * @returns
   */
    async createKzs(params) {
      const { data } = await this.api.post(`${APP_HOST}v2/monitoring/kzs/create`, params);
      return data;
    }
};

export default KzsApi;
